import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/shifts' },
    { path: '/login', name: 'login', component: () => import('../views/LoginView.vue'), meta: { public: true } },
    { path: '/vetting', name: 'vetting', component: () => import('../views/OnboardingView.vue') },
    { path: '/referrals', name: 'referrals', component: () => import('../views/ReferralsView.vue'), meta: { tab: 'profile' } },
    { path: '/shifts', name: 'shifts', component: () => import('../views/ShiftsView.vue'), meta: { tab: 'shifts' } },
    { path: '/my-shifts', name: 'my-shifts', component: () => import('../views/MyShiftsView.vue'), meta: { tab: 'my-shifts' } },
    { path: '/learn', name: 'learn', component: () => import('../views/LearnView.vue'), meta: { tab: 'learn' } },
    { path: '/earnings', name: 'earnings', component: () => import('../views/EarningsView.vue'), meta: { tab: 'earnings' } },
    { path: '/profile', name: 'profile', component: () => import('../views/ProfileView.vue'), meta: { tab: 'profile' } },
    { path: '/:pathMatch(.*)*', redirect: '/shifts' },
  ],
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(to => {
  const auth = useAuthStore()

  if (to.meta.public) {
    return auth.isAuthenticated ? { name: 'shifts' } : true
  }
  if (!auth.isAuthenticated) {
    return { name: 'login' }
  }
  // Browsing is deliberately open: seeing real shifts and real pay is what
  // persuades someone to finish signing up. CLAIMING is what requires
  // vetting, and the server enforces that regardless of this router.
  return true
})

export default router
